var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleGalka(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 77,
    rx: 38.5,
    stroke: "#004529",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.8353 28.4138C58.2391 28.8181 58.4659 29.3661 58.4659 29.9376C58.4659 30.509 58.2391 31.057 57.8353 31.4613L37.7103 51.5863C37.306 51.9901 36.758 52.2169 36.1866 52.2169C35.6152 52.2169 35.0671 51.9901 34.6628 51.5863L23.1628 40.0863C22.951 39.8889 22.7811 39.6509 22.6632 39.3864C22.5454 39.1219 22.482 38.8363 22.4769 38.5468C22.4718 38.2573 22.525 37.9697 22.6335 37.7012C22.7419 37.4327 22.9034 37.1888 23.1081 36.9841C23.3129 36.7793 23.5568 36.6179 23.8253 36.5095C24.0937 36.401 24.3813 36.3477 24.6709 36.3529C24.9604 36.358 25.2459 36.4213 25.5104 36.5392C25.7749 36.657 26.0129 36.827 26.2103 37.0388L36.1866 47.0151L54.7878 28.4138C55.1921 28.01 55.7402 27.7832 56.3116 27.7832C56.883 27.7832 57.431 28.01 57.8353 28.4138Z",
    fill: "#004529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleGalka);
export default __webpack_public_path__ + "static/media/circleGalka.5bc2209ae9531869fb1aee1d0b7ddeb4.svg";
export { ForwardRef as ReactComponent };